module.exports = __webpack_public_path__ + "components/rewards/absolutely-snow/static/icon-143cccaedda4aa3f6ac23ea2eae8d8ce.jpg";